export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500italic-0d8bb5b3ee5f5dac9e446d48480d28a9.woff2";